import React from "react";
import { Grid, Box } from "@mui/material";
import classes from "./MainPage_login.module.css";

function Loading() {
  return (
    <Box className={classes.mainpage}>
      <Grid container>
        <Grid item xs={12} className={classes.middleside}></Grid>
      </Grid>
    </Box>
  );
}

export default Loading;
